// Icone padrao de assistencia do sistema (emseg-icones-sistema/icons/assistencia.svg).
export default function IconAssistencia({ size = 16, style, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      role="img" aria-label="Assistência" style={{ display: 'block', ...style }} {...props}>
      <path d="M4 13v-2a8 8 0 0 1 16 0v2" />
      <path d="M6 17H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h2v6a3 3 0 0 0 3 3h3" />
      <path d="M18 12h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1v-5zM13 21h2" />
    </svg>
  )
}
